module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9r8r3r6n-daa58f054fcdef3a6dc84c265165dfd2.svg";